var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReceiptIcon = function SvgReceiptIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "receipt-icon_svg__a",
    d: "M0 0h16v13l-3.98 3-2.905-2-3.177 2-2.879-2L0 16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#receipt-icon_svg__a",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    d: "M.5.5v14.576l2.568-1.679 2.883 2.004 3.177-2 2.879 1.983L15.5 12.75V.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M3 3h10v1H3zm0 3h6v1H3zm8 0h2v1h-2zM3 9h6v1H3zm8 0h2v1h-2z"
  }))));
};
export default SvgReceiptIcon;